import {Nullable} from "@data-force/app";
import {RefObject} from "react";
import {SET_FOCUSED_ELEMENT} from "./availableActions";
import {SetFocusedElementAction} from "../../interfaces/store/actions/focusElement";

export const setFocusedElement = (payload: Nullable<RefObject<HTMLElement>>): SetFocusedElementAction => ({
    type: SET_FOCUSED_ELEMENT,
    payload,
});
